import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { BreadcrumbService } from '../../core/service/breadcrumb.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.css'
})
export class SideNavComponent implements OnInit {
 
  steps: any[] = []; // Local copy of the steps
  isSideNavOpen:boolean=false;
  isDesktop:boolean=false;
  isMobile:boolean=false;
  currentStep =1;
  activeStepIndex:number=0;
 
  constructor(private breadcrumbService: BreadcrumbService,private el: ElementRef) {}
 
  ngOnInit() {

     // Add event listener when component initializes
     document.addEventListener('click', this.onDocumentClick);

    // Subscribe to the steps from the service
    this.breadcrumbService.steps$.subscribe((steps) => {
      this.steps = steps;
    });

    console.log('mobile:',this.steps);

    this.breadcrumbService.sideNav$.subscribe((obj)=>{
      console.log(obj);
      if(obj === true){
        this.toggleSideNav();
      }
      // else{
      //   this.isSideNavOpen=false;
      // }
    })

    this.breadcrumbService.activeStepIndex$.subscribe((index:any) => {
      this.activeStepIndex = index;
    });
  }

 

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkDevice();
  }

  private checkDevice() {
    this.isDesktop = (window.innerWidth <= 769)?true:false;
    this.isMobile=window.innerWidth <= 768
    
    if(this.isDesktop){
      console.log('side nav in desktop verision');
      this.isSideNavOpen=false;
    }
    // else if(this.isMobile){
    //   console.log('side nav in mobile verision');
    // }
  }

  toggleSideNav(){
    this.isSideNavOpen=!this.isSideNavOpen;
  }
 
  // Handle step click
  onStepClick(index: number) {
    console.log(index,"side nav component selection")
    this.currentStep=index;
    this.activeStepIndex =index;
    // Set the active step globally
    // this.breadcrumbService.setActiveStep(index);
    this.breadcrumbService.updateActiveStep(index);
    this.isSideNavOpen=false;
 
    // Perform any additional logic (e.g., navigating to a section)
    console.log('Navigating to step:', this.steps[index].label);
  }

  showNonActiveFeedback(event: Event): void {
    console.log('came here non active');
    // Prevent any unintended navigation
    event.stopPropagation();
   
    // Add the shake animation to the target breadcrumb
    const target = event.target as HTMLElement;
    target.classList.add('shake');
   
    // Remove the shake animation after it's done
    setTimeout(() => target.classList.remove('shake'), 300);
   
    console.log('Inactive breadcrumb clicked, shaking animation triggered.');
  }
   
  // Check if the connector between the active step and the next should be highlighted
  isConnectorActive(indexvalue: number): boolean {
    let retuenObj:any;
    // We want to highlight the connector only between active steps, not from the first step by default that is the reason we passing i+1 from html
   this.steps.forEach((x:any,index:number)=>{
    if(index === indexvalue){
      retuenObj=(x.active === true)?  true : false;
    }
   })
   
    // return index < this.activeStepIndex;
    return retuenObj;
  }

  closeSideNav(){
    this.isSideNavOpen=false;
  }

    // Close the side nav if clicked outside
    onDocumentClick = (event: MouseEvent): void => {
      if (this.el.nativeElement && !this.el.nativeElement.contains(event.target)) {
        console.log('entered close event')
        this.isSideNavOpen = false; // Close the side nav
      }
    };
   

   // Prevent side nav from closing if clicked inside 'if user clicks on the side nav itself we prevent the events closing'
   onSideNavClick(event: MouseEvent): void {
    
    console.log('entered prevent event')
    event.stopPropagation();
  }

  ngOnDestroy(): void {
    // Remove event listener when component is destroyed
    document.removeEventListener('click', this.onDocumentClick);
  }

 
}